import { render, staticRenderFns } from "./BatchesForm.vue?vue&type=template&id=8684ef56&scoped=true"
import script from "./BatchesForm.vue?vue&type=script&lang=js"
export * from "./BatchesForm.vue?vue&type=script&lang=js"
import style0 from "./BatchesForm.vue?vue&type=style&index=0&id=8684ef56&prod&scoped=true&lang=css"
import style1 from "./BatchesForm.vue?vue&type=style&index=1&id=8684ef56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8684ef56",
  null
  
)

export default component.exports